/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { call, select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  Configs,
  Asset,
  PlaybackLicenseResult,
  PlaybackContextApi,
  PlaybackAssetType,
  Stream,
  PlaybackLicenseData,
  Ducks,
} from '@wit/vtv-x-foundation-lib';
import { getLicensedLink as getLicensedLinkCacheEnabled } from './channelsLicensePrefetch';
import AuthNUtils from './authNUtils';

function* isLicensedLinksCacheEnable(): SagaIterator<boolean> {
  const configs: Configs | undefined = yield select(Ducks.Dms.Selectors.getDmsConfigs);
  return (configs && configs.licensedLinkLifetime > 0) || false;
}

function* getLicensedLinkCacheDisabled(asset: Asset, streamId: number): SagaIterator<PlaybackLicenseResult> {
  return yield Ducks.Api.callApi(PlaybackContextApi.getPlaybackData, asset.id, PlaybackAssetType.MEDIA, streamId);
}

function* getPlaybackData(asset: Asset, stream: Stream): SagaIterator<PlaybackLicenseData> {
  const cacheEnabled = yield call(isLicensedLinksCacheEnable);

  const licensedLinkMethod: (asset: Asset, streamId: number) => SagaIterator<PlaybackLicenseResult> = cacheEnabled
    ? getLicensedLinkCacheEnabled
    : getLicensedLinkCacheDisabled;

  const result: PlaybackLicenseResult = yield call(licensedLinkMethod, asset, stream.id);

  if (!result.clearContent) {
    // update the token with the authN
    result.data.token = yield call(AuthNUtils.getAuthN);
  }

  return result.data;
}

function* getPlaybackLicenseLink(asset: Asset, stream: Stream): SagaIterator<PlaybackLicenseResult> {
  return yield Ducks.Api.callApi(PlaybackContextApi.getPlaybackUrl, asset.id, PlaybackAssetType.MEDIA, stream.id);
}

export default {
  getPlaybackData,
  getPlaybackLicenseLink,
};
